import { ModalMark } from './ModalMark';

export default ModalMark;
